import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const FIRESTORE_DB = (import.meta.env.VITE_FIRESTORE_DB as string | undefined) ?? 'studio-console';

export const app = initializeApp(config);
export const auth = getAuth(app);
export const db = getFirestore(app, FIRESTORE_DB);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

export const PROXY_URL = (import.meta.env.VITE_PROXY_URL as string | undefined)
  ?? 'http://localhost:8080';
